import React, { useEffect, useMemo, useRef, useState } from "react";
import { useHistory } from "react-router-dom";

import { IonIcon, IonToolbar, IonPage, IonContent, IonHeader, IonModal } from "@ionic/react";

import { Typography, Spin, Row, Col, Button, DatePicker } from "antd";
import {} from "@ant-design/icons";

import { menuOutline, closeOutline, calendar, cloudDownloadOutline } from "ionicons/icons";

import SideMenu from "../../../components/orderWatcher/menu";
import OrderDetail from "../../../components/orderWatcher/reportOrderDetail";
import OrderList from "../../../components/orderWatcher/orderList";

import moment from "moment-timezone";
import c from "../../../utils/common";
import axios from "axios";
import metaData from "../../../data/metaData";
import socket from "../../../components/socket";
import csvUtil from "../../../utils/csv";

/* Global State*/ 


import { v4 as uuidv4 } from "uuid";
import { useTranslation } from "react-i18next";

import deepcopy from "deepcopy";

const key = "updatable";
const { Paragraph } = Typography;
const { RangePicker } = DatePicker;
let globalState = undefined;

const FC = () => {
  
  const history = useHistory();
  const { t, i18n } = useTranslation();

  const [is_loading_orders, set_is_loading_orders] = useState(false);
  const [is_loading_full_order, set_is_loading_full_order] = useState(false);

  const [selected_order_id, set_selected_order_id] = useState();

  //Date Picker
  const [reportTime, set_reportTime] = useState();
  const [is_show_timepicker_modal, set_is_show_timepicker_modal] = useState(false);

  //Side Menu
  const [is_show_side_menu, set_is_show_side_menu] = useState(false);

  //Order List
  const [orders, set_orders] = useState([]);
  const [filter_status, set_filter_status] = useState("all");

  const today = moment(globalState.today);

  const style = {
    order_font_1: 28,
    order_font_2: 22,
    order_font_3: 18,
    order_font_4: 14,
  };

  const get_takeaway_orders = async (time, expand) => {
    set_is_loading_orders(true);
    console.log("get_takeaway_orders...");
    const query = `?vendorId=${globalState?.user?.vendorId}&start=${time.start}&end=${time.end}&status=cancel_before_accept&status=accepted&status=rejected&status=cancel_after_accept&status=collected&expand=${expand}`;
    console.log(query);

    const res = await axios.get(globalState.serverURL + "takeaway/order" + query, {
      headers: { Authorization: globalState.auth.jwt },
    });
    console.log(res);
    set_is_loading_orders(false);

    if (res.data.status == "Error") {
      return [];
    } else if (res.data.status == "Success") {
      set_orders(res.data.data);
      return res.data.data;
    }
  };

  const get_full_order_detail = async (orderId) => {
    set_is_loading_full_order(true);
    console.log("get_full_order_detail...");
    const query = `?id=${orderId}`;
    const res = await axios.get(globalState.serverURL + "takeaway/order" + query, {
      headers: { Authorization: globalState.auth.jwt },
    });
    set_is_loading_full_order(false);
    console.log(res);
    if (res.data.status == "Error") {
      //
    } else if (res.data.status == "Success") {
      set_orders((prev) => {
        return prev.map((e) => {
          if (e.id == res.data.data.id) {
            //replace order with full detail
            return res.data.data;
          } else {
            return e;
          }
        });
      });
    }
  };

  const getOrderTotal = (order) => {
    if (order == null) {
      return 0;
    }
    let total = 0;
    for (let i of order.items) {
      total += getItemTotal(i);
    }
    return total;
  };

  const getItemTotal = (item) => {
    let singleItemPrice = item.drink == null ? item.price : item.price + item.drink.price;
    return singleItemPrice * item.qty;
  };

  const exportReport = async () => {
    let orders = await get_takeaway_orders(reportTime, true);

    //set csv data before generate report
    let csvData = getCSVData(orders);
    csvUtil.exportToCSV({
      fileName: "takeaway_report",
      csvData: csvData,
    });
  };

  const getCSVData = (orders) => {
    let csvData = [];
    for (let k = 0; k < orders.length; k++) {
      let order = orders[k];
      console.log(order);
      for (let i = 0; i < order.items.length; i++) {
        let item = order.items[i];
        console.log(item);
        let row = {};
        row["下單時間"] = moment(order.time?.place).format("YYYY-MM-DD HH:mm:ss");
        row[t("DCredeem.status")] = getStatusCHN(order.status);
        row["總額"] = getOrderTotal(order);
        row["訂單編號"] = order.id;
        row["餐款名"] = item.name;
        row["餐款數量"] = item.qty;
        row["餐款價錢"] = item.price;
        row["餐款總額"] = getItemTotal(item);
        row["員工:接單"] = order.acceptBy?.email;
        row["員工:提取"] = order.collectBy?.assistant?.email;
        row["員工:拒絕"] = order.rejectBy?.email;
        row["員工:取消"] = order.cancelAfterAcceptBy?.email;
        row[t("DCredeem.consumerEmail")] = order.placeBy?.tel;
        csvData.push(row);
      }
    }
    // console.log(csvData);
    return csvData;
  };

  const getStatusCHN = (status) => {
    const map = {
      accepted: "己接受",
      collected: "己提取",
      rejected: "拒絕接單",
      cancel_before_accept: "接單前取消",
      cancel_after_accept: "接單後取消",
    };
    return map[status];
  };

  const log_out = () => {
    // Clean up the connection when unmounts
    clearSocket();

    // globalActions.logOut();
    history.push("/login");
  };

  const clearSocket = () => {
    if (socket) {
      socket.removeAllListeners();
      socket.disconnect();
    }
  };

  /**
   * Render Component
   */

  const Header = () => {
    return (
      <IonHeader>
        <IonToolbar>
          <Row>
            {/* Logo */}
            <Col
              flex="none"
              style={{
                // backgroundColor: "red",
                padding: "20px 30px 20px 30px",
              }}
            >
              <Row justify="space-between" align="middle" style={{ width: "100%" }}>
                <Col>
                  <img
                    style={{
                      width: "50px",
                      height: "50px",
                      borderRadius: "5px",
                    }}
                    src={metaData.blobPreURL + metaData.appLogoPath + metaData.blobPostURL}
                  ></img>
                </Col>
              </Row>
            </Col>

            {/* PlaceHolder */}
            <Col
              flex="auto"
              style={{
                //backgroundColor: "blue",
                padding: 20,
              }}
            ></Col>

            {reportTime?.start != null && reportTime?.end != null ? (
              <Col flex="none">
                <Row
                  align="middle"
                  style={{ height: "100%", borderLeft: "3px solid #F1F1F1", padding: 20, fontSize: 24 }}
                  onClick={() => {
                    exportReport();
                  }}
                >
                  <IonIcon icon={cloudDownloadOutline} style={{ marginRight: 10 }} />
                  下載報告
                </Row>
              </Col>
            ) : null}

            {/* TimePicker */}
            <Col flex="none">
              <Row
                align="middle"
                style={{ height: "100%", borderLeft: "3px solid #F1F1F1", padding: 20, fontSize: 24 }}
                onClick={() => {
                  set_is_show_timepicker_modal(true);
                }}
              >
                <Row>
                  <IonIcon icon={calendar} style={{ marginRight: 20 }} />
                </Row>
                <Row style={{ fontWeight: "bold" }}>
                  {reportTime?.start != null && reportTime?.end != null
                    ? `${moment(reportTime.start).format("YYYY/MM/DD")} - ${moment(reportTime.end).format(
                        "YYYY/MM/DD"
                      )}`
                    : "選擇日期"}
                </Row>
              </Row>
            </Col>

            {/* Menu */}
            <Col
              flex="none"
              style={{
                //backgroundColor: "green",
                padding: "20px 30px 20px 30px",
                borderLeft: "3px solid #F1F1F1",
              }}
              onClick={() => {
                set_is_show_side_menu(true);
              }}
            >
              <Row align="middle" style={{ height: "100%" }}>
                <IonIcon style={{ fontSize: 48 }} icon={menuOutline} />
              </Row>
            </Col>
          </Row>
        </IonToolbar>
      </IonHeader>
    );
  };

  const TimePickerModal = () => {
    const [temp_report_time, set_temp_report_time] = useState();

    return (
      <IonModal
        isOpen={is_show_timepicker_modal}
        cssClass="center-round-modal auto-height"
        onDidDismiss={() => {
          set_is_show_timepicker_modal(false);
        }}
        mode="ios"
        swipeToClose
      >
        <Row style={{ width: "40vw", padding: 20, fontWeight: "bold" }} className="inner-content">
          <Row justify="space-between" style={{ width: "100%", marginBottom: 20 }}>
            <Col style={{ fontSize: 22 }}>選擇日期</Col>
            <Col
              onClick={() => {
                set_is_show_timepicker_modal(false);
              }}
            >
              <IonIcon style={{ fontSize: 28 }} icon={closeOutline}></IonIcon>
            </Col>
          </Row>

          <Row justify="end" align="middle" style={{ height: "100%" }}>
            <RangePicker
              size="large"
              style={{ width: "100%" }}
              allowClear={false}
              onChange={(value) => {
                let start = value && value[0] != null ? value[0].format("YYYY-MM-DD") : null;
                let end = value && value[1] != null ? value[1].format("YYYY-MM-DD") : null;
                let time = start == null || end == null ? null : { start, end };

                //console.log(time);
                set_temp_report_time(time);
              }}
              //defaultPickerValue={default_voucher_picker_date()}
              //value={get_collectTime_moment_object(item.time)}
            />
            <Button
              type="primary"
              size="large"
              disabled={temp_report_time == null}
              style={{ width: "100%", marginTop: 20 }}
              onClick={() => {
                //get data
                get_takeaway_orders(temp_report_time, false);

                //update value
                set_reportTime(temp_report_time);

                //unselect order
                set_selected_order_id();

                //reset filter_status
                set_filter_status("all");

                set_is_show_timepicker_modal(false);
              }}
            >
              套用
            </Button>
          </Row>
        </Row>
      </IonModal>
    );
  };

  const orders_filtered = useMemo(() => {
    console.log(orders.length);
    console.log({ filter_status });

    //early exit
    if (orders.length == 0) {
      return [];
    }

    let filtered = [];

    //filter by status
    filtered = filter_status == "all" ? orders : orders.filter((e) => e.status == filter_status);

    console.log(filtered.length);

    return filtered;
  }, [orders, filter_status]);

  const selected_order = useMemo(() => {
    return orders_filtered.find((e) => e.id == selected_order_id);
  }, [orders_filtered, selected_order_id]);

  return (
    <IonPage>
      <Header />

      <SideMenu
        isShow={is_show_side_menu}
        history={history}
        onClose={() => {
          set_is_show_side_menu(false);
        }}
        onLogOut={() => {
          log_out();
        }}
      />

      <TimePickerModal />

      <IonContent style={{ "--overflow": "hidden" }}>
        <Row
          align="middle"
          style={{
            borderBottom: "3px solid #F1F1F1",
          }}
        >
          <Col flex="auto">
            <Row justify="start" align="middle" style={{ fontWeight: "bold", borderRight: "3px solid #F1F1F1" }}>
              {[
                { label: "全部", status: "all", fontSize: 20 },
                { label: "已接受", status: "accepted", fontSize: 20 },
                { label: "已提取", status: "collected", fontSize: 20 },
                { label: "拒絕接單", status: "rejected", fontSize: 20 },
                { label: "接單前取消", status: "cancel_before_accept", fontSize: 20 },
                { label: "接單後取消", status: "cancel_after_accept", fontSize: 20 },
              ].map((e, i) => (
                <Col
                  span={4}
                  key={i}
                  style={{
                    padding: 10,
                    fontSize: e.fontSize,
                    lineHeight: "normal",
                    backgroundColor: filter_status == e.status ? "#F2E8FF" : "white",
                  }}
                  onClick={() => {
                    set_filter_status(e.status);
                  }}
                >
                  <Row>{e.label}</Row>
                  <Row style={{ fontSize: 30, color: "#CB4DCD" }}>
                    {orders.length > 0
                      ? e.status == "all"
                        ? orders.length
                        : orders.filter((x) => x.status == e.status).length
                      : 0}
                  </Row>
                </Col>
              ))}
            </Row>
          </Col>
        </Row>

        <Row style={{ height: "100%" }}>
          {/* Order List */}
          <Col span={8} style={{ height: "100%" }}>
            <OrderList
              is_loading_orders={is_loading_orders}
              orders_filtered={orders_filtered}
              selected_order_id={selected_order_id}
              onSelect={(orderId) => {
                if (selected_order_id == orderId) {
                  //unselect
                  set_selected_order_id();
                } else {
                  //select
                  set_selected_order_id(orderId);
                }
              }}
              css={{ height: "calc(100% - 80px)" }}
              isReport
            />
          </Col>

          <Col span={16} style={{ padding: 20, height: "100%" }}>
            <OrderDetail
              order={selected_order}
              is_loading_full_order={is_loading_full_order}
              onGetFullDetail={(orderId) => {
                get_full_order_detail(orderId);
              }}
            />
          </Col>
        </Row>
      </IonContent>
    </IonPage>
  );
};

export default FC;
